import { Typography } from '@mui/material';
import * as React from 'react';
import { getLuminaryBitStatusState, LUMINARY_BIT_STATUS } from '../../app/enum/ENUM';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';

type Props = {
    bitStatus: Array<number>;
    index: string;
}

const CGLineLuminaryListItem: React.FC<React.PropsWithChildren<React.PropsWithChildren<Props>>> = (props: Props) => {

    const { t } = useLanguageLocale();

    // Default to an empty array if bitStatus is not provided
    const bitStatus = props.bitStatus || [];

    const isFailure = bitStatus.some((status) =>
        [LUMINARY_BIT_STATUS.STATUS_COMMUNICATION_FAILURE,
        LUMINARY_BIT_STATUS.STATUS_BATTERY_FAILURE,
        LUMINARY_BIT_STATUS.STATUS_LAMP_FAILURE,
        LUMINARY_BIT_STATUS.STATUS_CHARGE_FAILURE,
        LUMINARY_BIT_STATUS.STATUS_FT_FAILURE,
        LUMINARY_BIT_STATUS.STATUS_DT_FAILURE].includes(status));

    return (
        <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            columnGap: 5
        }}
            key={props.index}>
            {
                bitStatus.map((status, i) => {
                    return <div key={i} style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        columnGap: 5
                    }}
                        title={t(getLuminaryBitStatusState(status).statusTitle)}>
                        <img
                            src={getLuminaryBitStatusState(status).statusImage}
                            alt="logo"
                            id="luminary-status-icon"
                            style={{ width: 20, height: 20 }}
                            data-testid="luminary-status-icon"
                        />
                        {
                            bitStatus.length === 1 &&
                            <Typography
                                id="device-status-button"
                                data-testid="device-status-button"
                                style={{ textTransform: 'none', marginLeft: 5 }} variant="body2">
                                {t(getLuminaryBitStatusState(status).statusTitle)}
                            </Typography>
                        }
                    </div>
                })
            }
            {
                (isFailure && bitStatus.length > 1) &&
                <Typography
                    id="device-status-button"
                    data-testid="device-status-button"
                    style={{ textTransform: 'none', marginLeft: 5 }} variant="body2">
                    {t('STATUS.FAILURE')}
                </Typography>
            }
        </div>
    );

}

export default CGLineLuminaryListItem;
